import { Modal } from "@mui/material";
import React from "react";
import Styles from "./ViewProfile.module.css";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";

const normalizeStatus = (status) => {
  if (!status) return "";
  const s = status.toUpperCase();
  if (s === "LEDGER") return "LEDGER";
  if (s === "TERMS_ACCEPTED") return "ACCEPTED";
  if (s === "COMPLETED") return "ONGOING";
  if (s === "HOLD") return "HOLD";
  return s;
};

const ViewProfile = ({ open, handleClose, data, connectionStatusRaw }) => {
  const userData = useSelector((state) => state.persistedReducer);

  const voltageLevels = userData?.user?.discoms?.[0]?.voltageLevels || [];
  const discomName = userData?.user?.discoms?.[0]?.discomName || [];

  const connectionStatus = normalizeStatus(connectionStatusRaw);
  const allowedStatuses = new Set([
    "LEDGER",
    "TERMS_INITIATED",
    "TERMS_ACCEPTED",
    "COMPLETED",
    "ACCEPTED",
    "ONGOING",
  ]);
  const showCompanyName =
    allowedStatuses.has(connectionStatusRaw) ||
    allowedStatuses.has(connectionStatus);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">
              Profile
              <span className={Styles.headerName}>{data?.name}</span>
            </div>
            <Close
              style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div
            className={`display_flex_row_center ${Styles.profileDetailsSection}`}
          >
            {/* <div className={` ${Styles.profileDetails}`}>
              <div>{data?.name}</div>
              <div className={Styles.detailsSec}>
                <div>
                  GSTIN{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "var(--sixth-color-text)",
                      paddingLeft: "5px",
                    }}
                  >
                    27AAAAP0267H2ZN
                  </span>
                </div>
                <div>
                  TAN{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "var(--sixth-color-text)",
                      paddingLeft: "5px",
                    }}
                  >
                    PDES03028F
                  </span>
                </div>
                <div>
                  PAN{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "var(--sixth-color-text)",
                      paddingLeft: "5px",
                    }}
                  >
                    ABCTY1234D
                  </span>
                </div>
              </div>
            </div> */}
            <div className={Styles.companyInformation}>
              <div className={Styles.companyHeader}>
                <span>Company Information</span>
              </div>
              <div className={Styles.companyBottomPart}>
                <div
                  className={`${Styles.companyDetailsPart} ${
                    !showCompanyName ? Styles.blurred : ""
                  }`}
                >
                  <span>Company Name</span>
                  <span>
                    {" "}
                    {showCompanyName
                      ? data?.companyDetails?.displayName ?? "***********"
                      : "***********"}
                  </span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span>City</span>
                  <span>{data?.companyDetails?.city ?? "NA"}</span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span>State</span>
                  <span>{data?.companyDetails?.state ?? "NA"}</span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span>Credit Rating</span>
                  <span>{data?.companyDetails?.creditRating ?? "NA"}</span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span>Credit Rating Year</span>
                  <span>{data?.companyDetails?.creditRatingYear ?? "NA"}</span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span>Credit Rating Agency</span>
                  <span>
                    {data?.companyDetails?.creditRatingAgency ?? "NA"}
                  </span>
                </div>
              </div>
            </div>

            <div className={Styles.companyInformation}>
              <div className={Styles.companyHeader}>
                <span>Discom Information</span>
              </div>
              <div className={Styles.discomBottomPart}>
                <div
                  className={`${Styles.companyDetailsPart} ${
                    !showCompanyName ? Styles.blurred : ""
                  }`}
                >
                  <span>Specification</span>
                  <span>
                    {showCompanyName
                      ? data?.companyDetails?.discomName ?? "NA"
                      : "***********"}
                  </span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span style={{ width: "100%" }}>Voltage Level</span>
                  <span>
                    {data?.companyDetails?.voltageLevels &&
                    data.companyDetails.voltageLevels.length > 0
                      ? data.companyDetails.voltageLevels.join(", ")
                      : "NA"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`display_flex_row_center ${Styles.buttonMainContainer}`}
          >
            <div className={Styles.cancelBankButton} onClick={handleClose}>
              Cancel
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ViewProfile;
